<template>
  <ul>
    <li v-for="(cellInfo, index) in cellList" :key="'cell_' + index" class="category-item">
      <a href="#" @click.prevent="goDetail(cellInfo)">
          <span :class="highlightClass(cellInfo)">
            <span class="a11y-hidden">웨이브 추천 메뉴</span>
          </span>
        <span class="category-item-name">{{itemTitle(cellInfo)}}</span>
      </a>
    </li>
  </ul>
</template>

<script>
import { selectCell } from '@/common/util/common'
import { get } from 'lodash'
import { topTagList } from '@/common/directives'
import { getEventListByType } from '@/common/util/event.util'
import utils from '@/common/util/utils'
import { ADULT_SETTINGS_KEY, COOKIE_KEY_VERIFIED_ADULT, URL_COOKIE_DOMAIN } from '@/common/constant'
import { verifyAdultContentProtectionState, getAdultVerificationStatus } from '@/common/api/api.service'
import { EventBus } from '@/components/eventbus/EventBus'
import { mapMutations, mapGetters } from 'vuex'
import { PATH_NAME_ADULTVERIFY_UNLOCK } from '@/common/router.const'
export default {
  name: 'CellListCategory',
  props: {
    cellList: {
      type: Array
    }
  },
  directives: { topTagList },
  data () {
    return {
      onNavigationEvent: {}
    }
  },
  computed: {
    ...mapGetters(['isVisibleAdultCheckView'])
  },
  methods: {
    ...mapMutations(['showAdultCheck', 'hideAdultCheck']),
    removeEvent () {
      EventBus.$off('on-exit')
      EventBus.$off('on-enter')
    },
    setCookie () {
      let expires = new Date()
      expires.setHours(expires.getHours() + 6)
      utils.cookies.setItem(COOKIE_KEY_VERIFIED_ADULT, '1', expires.toUTCString(), URL_COOKIE_DOMAIN, '/')
    },
    async verifyAdult (cell) {
      const isLoginUser = utils.cookies.getCredential() !== 'none'
      if (isLoginUser) {
        const response = await getAdultVerificationStatus()
        if (get(response, 'data.settings', 'N') !== utils.cookies.getItem(ADULT_SETTINGS_KEY)) {
          utils.cookies.removeItem(COOKIE_KEY_VERIFIED_ADULT, URL_COOKIE_DOMAIN, '/')
          utils.cookies.setAdultContentSettingsValue(get(response, 'data.settings', 'N'))
        }
      }
      await utils.common.userInfoAdultVerifiedDate()
      const isVerifiedAdult = utils.cookies.getItem(COOKIE_KEY_VERIFIED_ADULT) === '1'
      const settings = utils.cookies.getItem(ADULT_SETTINGS_KEY)
      if (isLoginUser) {
        if (isVerifiedAdult) {
          selectCell(cell)
        } else {
          if (settings === 'L') {
            await this.$router.replace({
              name: PATH_NAME_ADULTVERIFY_UNLOCK,
              query: {
                referer: this.getBeforeEnterPlayerPath
              },
              params: {
                action: async ({ pincode, resetFn }) => {
                  try {
                    const result = await verifyAdultContentProtectionState(pincode)
                    const { resultcode } = result.data
                    if (resultcode === '200') {
                      this.setCookie()
                      selectCell(cell)
                    }
                  } catch (e) {
                    if (typeof resetFn === 'function') {
                      resetFn()
                    }
                  }
                },
                enter: this.$route.fullPath
              }
            })
          } else {
            EventBus.$once('on-exit', () => {
              this.hideAdultCheck()
              this.removeEvent()
            })
            EventBus.$once('on-enter', () => {
              this.hideAdultCheck()
              this.removeEvent()
              selectCell(cell)
            })
            this.showAdultCheck()
          }
        }
      } else {
        await this.$router.replace(`/login?referer=${this.$route.fullPath}`)
      }
    },
    toastItem (cell, onNavigationEvent) {
      this.$toast({ message: get(onNavigationEvent, 'toast_text', '') })
      setTimeout(() => {
        if (get(this.onNavigationEvent, 'adult', 'n').toLowerCase() === 'y') {
          this.verifyAdult(cell)
        } else {
          selectCell(cell)
        }
      }, 2000)
    },
    goDetail (cell) {
      this.onNavigationEvent = get(getEventListByType(get(cell, 'event_list', [])), 'onNavigationEvent', {})
      if (get(this.onNavigationEvent, 'toast_text', '') !== '') {
        this.toastItem(cell, this.onNavigationEvent)
      } else if (get(this.onNavigationEvent, 'adult', 'n').toLowerCase() === 'y') {
        this.verifyAdult(cell)
      } else {
        selectCell(cell)
      }
    },
    itemTitle (cell) {
      return get(cell, 'title_list.0.text', '')
    },
    highlightClass (cell) {
      const topTagList = get(cell, 'top_taglist', [])
      if (topTagList.length > 0) {
        return topTagList.indexOf('highlight') > -1 ? 'highlight' : ''
      }
    }
  },
  beforeDestroy () {
    if (this.isVisibleAdultCheckView) {
      this.hideAdultCheck()
    }
  }
}
</script>
